// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"279":"component---src-pages-index-jsx","415":"component---src-pages-404-jsx"}[chunkId] || chunkId) + "-" + {"108":"977ac6fdbe152d1e8ad2","279":"678d56fe1a97430b50e3","415":"7bc739300f3151786627","452":"92b6e96023230189a0fa"}[chunkId] + ".js";
};